export default __webpack_public_path__ + "static/media/tempStore7.7205c44c.png";